import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FaChalkboardTeacher, FaCertificate, FaUsers, FaBook } from 'react-icons/fa';
import './CapacityBuilding.css';

const CapacityBuilding = () => {
  const programs = [
    {
      icon: <FaChalkboardTeacher />,
      title: 'Caregiver Training',
      description: 'Comprehensive training programs for aspiring caregivers covering basic patient care, hygiene, and safety protocols.'
    },
    {
      icon: <FaCertificate />,
      title: 'Certification Courses',
      description: 'Industry-recognized certification courses in home nursing, elderly care, and palliative care services.'
    },
    {
      icon: <FaUsers />,
      title: 'Skill Development',
      description: 'Advanced workshops on specialized care techniques, medical equipment usage, and emergency response.'
    },
    {
      icon: <FaBook />,
      title: 'Continuing Education',
      description: 'Regular refresher courses and updates on latest healthcare practices and regulatory compliance.'
    }
  ];

  return (
    <div className="capacity-building-page">
      <section className="page-hero">
        <Container>
          <h1>Capacity Building Programs</h1>
          <p>Empowering Healthcare Professionals Through Training</p>
        </Container>
      </section>

      <section className="program-intro">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} className="mb-4 mb-lg-0">
              <h2>Building Healthcare Excellence</h2>
              <p>
                Our capacity building initiatives are designed to enhance the skills and knowledge of 
                healthcare professionals, caregivers, and support staff. We believe that quality 
                training translates to better patient care.
              </p>
              <p>
                Through structured programs, hands-on workshops, and mentorship opportunities, we 
                help individuals develop the competencies needed to excel in home healthcare services.
              </p>
            </Col>
            <Col lg={6}>
              <img 
                src="https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=800" 
                alt="Capacity Building" 
                className="img-fluid rounded shadow"
              />
            </Col>
          </Row>
        </Container>
      </section>

      <section className="programs-section">
        <Container>
          <h2 className="text-center mb-5">Our Training Programs</h2>
          <Row className="g-4">
            {programs.map((program, index) => (
              <Col key={index} lg={6}>
                <Card className="program-card h-100">
                  <Card.Body className="d-flex">
                    <div className="program-icon">{program.icon}</div>
                    <div>
                      <h4>{program.title}</h4>
                      <p>{program.description}</p>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section className="enrollment-section">
        <Container>
          <div className="enrollment-card">
            <h2>Interested in Our Programs?</h2>
            <p>Join our capacity building initiatives and advance your healthcare career</p>
            <a href="tel:+919281474570" className="btn btn-warning btn-lg">
              Call for Enrollment
            </a>
          </div>
        </Container>
      </section>
    </div>
  );
};

export default CapacityBuilding;
